import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Part } from 'src/app/models/part';
import { InventoryService } from 'src/app/services/inventory.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-part',
  template: `
  <div class="d-flex flex-column mb-4 mt-4">
      <div class="flex-column">
        <h1>Partes</h1>
      </div>
      <div class="flex-column">
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
  <div class="d-flex mb-4 mt-4">
    <h2>Parte - {{part?.full_name}}</h2>
  </div>
  <div class="d-flex mb-4 mt-4">
    <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #sidebar class="list-unstyled">            
        <li><button class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts" >Partes</button></li>
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerlLink="/inventory">Inventario</button></li>
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders" >Compras</button></li>
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/sales">Ventas</button></li>
      </ul>
      <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Partes</h4>
      <ul #subsidebar class="list-unstyled">
        <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts/categories" >Categorías</button></li>
        <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" (click)="openModalPartCategory()" >Parámetros</button></!-->
      </ul>
    </div>
    <div class="flex-fill ms-3">
      <div class="list-group">
        <div class="list-group-item">
          <div class="d-flex">
            <div class="me-3"><img src="{{local}}{{ part?.image }}"></div>
            <div class="flex-fill">
              <div class="list-group">
                <div class="list-group-item">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p>Nombre</p>
                    </div>
                    <div class="text-end">{{part?.name}}</div>
                  </div>
                </div>
                <div class="list-group-item">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p>Descripción</p>
                    </div>
                    <div class="text-end">{{part?.description}}</div>
                  </div>
                </div>
                <div class="list-group-item">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p>Categoría</p>
                    </div>
                    <div class="text-end">{{part?.category}}</div>
                  </div>
                </div>
                <div class="list-group-item">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p>Ubicación predeterminada</p>
                    </div>
                    <div class="text-end">{{part?.default_location}}</div>
                  </div>
                </div>
                <div class="list-group-item">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p>IPN</p>
                    </div>
                    <div class="text-end">{{part?.IPN}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">
              <p>Activo</p>
            </div>
            <div class="text-end">
              <span *ngIf="part?.active" class="badge badge-pill bg-success">Sí</span>
              <span *ngIf="!part?.active" class="badge badge-pill bg-danger">{{part?.active}}</span>
            </div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">
              <p>Bloqueado</p>
            </div>
            <div class="text-end">
              <span *ngIf="part?.locked" class="badge badge-pill bg-success">Sí</span>
              <span *ngIf="!part?.locked" class="badge badge-pill bg-danger">{{part?.locked}}</span>
            </div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">
              <p>Parte adquirible</p>
            </div>
            <div class="text-end">
              <span *ngIf="part?.purchaseable" class="badge badge-pill bg-success">Sí</span>
              <span *ngIf="!part?.purchaseable" class="badge badge-pill bg-danger">{{part?.purchaseable}}</span>
            </div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">
              <p>Parte vendible</p>
            </div>
            <div class="text-end">
              <span *ngIf="part?.salable" class="badge badge-pill bg-success">Sí</span>
              <span *ngIf="!part?.salable" class="badge badge-pill bg-danger">{{part?.salable}}</span>
            </div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">
              <p>Parte virtual</p>
            </div>
            <div class="text-end">
              <span *ngIf="part?.virtual" class="badge badge-pill bg-success">Sí</span>
              <span *ngIf="!part?.virtual" class="badge badge-pill bg-danger">{{part?.virtual}}</span>
            </div>
          </div>
        </div>
      </div>      
    </div>
    <div class="ms-3 flex-fill">
      <div class="list-group">
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">En inventario</div>
            <div class="">{{part?.stock_item_count}}</div>
          </div>
        </div>        
      </div>
      <div class="list-group">
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">Fecha de creación</div>
            <div class="">{{part?.stock_item_count}}</div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">Creado por</div>
            <div class="">{{part?.stock_item_count}}</div>
          </div>
        </div>
        <div class="list-group-item">
          <div class="d-flex">
            <div class="flex-fill">Fecha de creación</div>
            <div class="">{{ part?.pricing_min | currency}} - {{ part?.pricing_max | currency}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  `,
  styleUrls: []
})
export class EditPartComponent {
  part: Part | null = null;
  invURL: string = environment.INV_REST_WSPREFIX;
  local: string = 'http://localhost:8000';

  constructor(
    private invService: InventoryService,
    private activeRoute: ActivatedRoute
  ) { 
    this.activeRoute.params.subscribe(params => {
      this.loadPart(params['id']);
    });
  }

  loadPart(id: number) {
    this.invService.getPartById(id).subscribe({
      next: (part: Part) => {
        console.log("part => ", part);
        this.part = part;
      },
      error: (err: any) => {}
    });
  }

}
